module.exports = __webpack_public_path__ + "media/images/icons/material/magnify-de1aa0a600473e0dfee828bf91302e63.svg";